import { MouseEventHandler } from "react";
import { Button } from "reactstrap";

const buttonStyles: object = {
  height: "38px",
  width: "38px",
  boxShadow: "none",
};

const chevronStyles: object = {
  fontSize: "20px",
  lineHeight: "1",
  position: "relative",
  top: "1px",
};

interface CollapseButtonProps {
  onClick: MouseEventHandler<HTMLButtonElement> | undefined;
  hidden?: boolean;
  css?: string;
}

const CollapseButton = ({
  onClick,
  hidden,
  css = "p-2",
}: CollapseButtonProps) => {
  return (
    <Button
      className={`btn-icon btn-link text-medium ${css}`}
      style={buttonStyles}
      color=""
      onClick={onClick}
    >
      <i
        className={hidden ? "mdi mdi-chevron-down" : "mdi mdi-chevron-right"}
        style={chevronStyles}
      ></i>
    </Button>
  );
};

export default CollapseButton;
